import { Navigate } from 'react-router-dom';
import { authController } from '../controllers/authController';

const PublicRoute = ({ children }) => {
  const isAuthenticated = authController.isAuthenticated();
  
  if (isAuthenticated) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;